<div class="card flex-xl-row mb-4 box-shadow h-md-250 pointer" routerLink="/articles/{{data.friendlyUrl}}">
    <div class="card-body d-flex flex-column align-items-start">
      <strong class="d-inline-block mb-2 text-primary">{{data.titletag}}</strong>
      <h3 class="mb-0">
        <a class="text-dark" routerLink="/articles/{{data.friendlyUrl}}">{{data.title}}</a>
      </h3>
      <div class="mb-1 text-muted"><small>{{data.date | date: "MMM d, yyyy"}}</small></div>
      <div [innerHTML]="data.teaser" class="card-text mb-auto"></div>
      <a routerLink="/articles/{{data.friendlyUrl}}">Continue reading</a>
    </div>
    <img class="card-img-right flex-auto d-md-block" src="{{data.posterUrl}}" alt="{{data.title}}" width="200" height="250" />
  </div>